<template>
  <p v-if="loading" class="mb-8">Adding New Ingredient...</p>
  <p v-if="error" class="mb-8">Something go wrong...</p>

  <button @click="createFormOpen = true" type="button" class="inline-block px-6 py-2.5 bg-green-500 text-white font-bold text-xs leading-tight uppercase rounded shadow-md hover:bg-green-600 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-lg transition duration-150 ease-in-out">
    Add Ingredient
  </button>

  <TransitionRoot as="template" :show="createFormOpen">
    <Dialog as="div" class="relative z-10" @close="createFormOpen = false; resetFormData()">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
              <div class="block p-6 rounded-lg shadow-lg bg-white">
                <h2 class="font-bold text-2xl mb-4">🥕 Add Ingredient </h2>

                <!--INPUT FORM-->
                <form @submit.prevent="handleSubmit(); resetFormData(); createFormOpen=false">

                  <div class="form-group mb-6">
                    <label for="exampleInputTitle" class="form-label inline-block mb-2 text-gray-700">Ingredient Name</label>
                    <input class="form-control
                                    block
                                    w-full
                                    px-3
                                    py-1.5
                                    text-base
                                    font-normal
                                    text-gray-700
                                    bg-white bg-clip-padding
                                    border border-solid border-gray-300
                                    rounded
                                    transition
                                    ease-in-out
                                    m-0
                                    focus:text-gray-700 focus:bg-white focus:border-green-600 focus:outline-none"
                           id="exampleInputEmail1"
                           v-model="formatData.name" required type="text"
                           aria-describedby="emailHelp" placeholder="Enter Name">
                  </div>

                  <div class="form-group mb-6">
                    <label for="exampleInputTitle" class="form-label inline-block mb-2 text-gray-700">Quantity</label>
                    <input class="form-control
                                    block
                                    w-full
                                    px-3
                                    py-1.5
                                    text-base
                                    font-normal
                                    text-gray-700
                                    bg-white bg-clip-padding
                                    border border-solid border-gray-300
                                    rounded
                                    transition
                                    ease-in-out
                                    m-0
                                    focus:text-gray-700 focus:bg-white focus:border-green-600 focus:outline-none"
                           id="exampleInputEmail1"
                           v-model="formatData.quantity" required type="number"
                           aria-describedby="emailHelp" placeholder="Enter Number">
                  </div>

                  <div class="flex w-full">
                    <div class="mb-8 xl:w-96">
                      <label for="exampleInputTitle" class="form-label inline-block mb-2 text-gray-700">Quantity Type</label>

                      <select class="form-select appearance-none
                                          block
                                          w-full
                                          px-3
                                          py-1.5
                                          text-base
                                          font-normal
                                          text-gray-700
                                          bg-white bg-clip-padding bg-no-repeat
                                          border border-solid border-gray-300
                                          rounded
                                          transition
                                          ease-in-out
                                          m-0
                                          focus:text-gray-700 focus:bg-white focus:border-green-600 focus:outline-none"
                              v-model="formatData.quantityType" required aria-label="Default select example">
                        <option value="">Select Quantity Type</option>
                        <option value="IBS">Ibs</option>
                        <option value="KG">Kg</option>
                        <option value="TEASPOON">Teaspoon</option>
                      </select>
                    </div>
                  </div>

                  <button  class="px-6
                                  py-2.5
                                  bg-green-600
                                  text-white
                                  font-bold
                                  text-xs
                                  leading-tight
                                  uppercase
                                  rounded
                                  shadow-md
                                  hover:bg-green-700 hover:shadow-lg
                                  focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0
                                  active:bg-green-800 active:shadow-lg
                                  transition
                                  duration-150
                                  ease-in-out"
                           type="submit">{{ loading ? "Add..." : "Add"}}
                  </button>

                  <button  class="px-6
                                  ml-2
                                  py-2.5
                                  bg-red-600
                                  text-white
                                  font-bold
                                  text-xs
                                  leading-tight
                                  uppercase
                                  rounded
                                  shadow-md
                                  hover:bg-red-700 hover:shadow-lg
                                  focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0
                                  active:bg-red-800 active:shadow-lg
                                  transition
                                  duration-150
                                  ease-in-out"
                           @click.prevent="createFormOpen = false">Cancel
                  </button>

                </form>
              </div>
              <!--END INPUT FORM-->

            </DialogPanel>
          </TransitionChild>

        </div>
      </div>

    </Dialog>
  </TransitionRoot>
</template>

<script>
import { useMutation } from "@vue/apollo-composable";
import gql from "graphql-tag";
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'

import {ref} from "vue";
import { useRoute } from "vue-router";

const createFormOpen = ref(false)

const ADD_INGREIDENT_TO_RECIPE = gql`
mutation AddIngredient($recipeID: ID!, $ingredientData: createIngredient!) {
  AddIngredient(id: $recipeID, Ingredient: $ingredientData) {
    id
    name
    instruction
    image
    ingredients {
      name
      quantity
      quantityType
    }
  }
}
`

export default {
  name: "IngredientForm",
  components:{Dialog, DialogPanel, TransitionChild, TransitionRoot},
  data()
  {
    return {
      formatData:{
        name:"",
        quantity:"",
        quantityType:""
      },
    }
  },
  methods:{
    resetFormData()
    {
      this.formatData.name = ""
      this.formatData.quantity = ""
      this.formatData.quantityType = ""
    },
    handleSubmit(){
      console.log(this.formatData)
      this.AddIngredient({
        recipeID: this.route.params.id,
        ingredientData: {
          name: this.formatData.name,
          quantity: this.formatData.quantity,
          quantityType: this.formatData.quantityType
        }
      })
    }
  },
  setup(){

    const route = useRoute()

    const { mutate:AddIngredient,loading,error } = useMutation(ADD_INGREIDENT_TO_RECIPE)

    return {
      AddIngredient,
      loading,
      error,
      createFormOpen,
      route
    }
  }

}
</script>

<style scoped>

</style>